// src/components/SeasonalRibbon.tsx
// Hanging pennant tag(s) that drop from the sticky header bar.
// Colors come from the active theme's CSS variables automatically.
import React from "react";
import { useTheme } from "../contexts/ThemeContext";

interface PennantConfig {
  /** Emoji glyph, or an <svg> element when no font can be trusted to render it */
  emoji: React.ReactNode;
  /** Short two-line label shown inside the pennant (use \n to break) */
  label: string;
}

const RIBBON_CONFIG: Partial<Record<string, PennantConfig>> = {
  july4th: { emoji: "🎆", label: "Happy\nJuly 4th" },
  america250: { emoji: "🎆", label: "America's\n250th!" },
};

const Pennant: React.FC<{ config: PennantConfig }> = ({ config }) => (
  <div className="seasonal-ribbon__inner">
    <span className="seasonal-ribbon__star" aria-hidden="true">
      ★
    </span>
    <span className="seasonal-ribbon__emoji" aria-hidden="true">
      {config.emoji}
    </span>
    <p className="seasonal-ribbon__tagline">{config.label}</p>
    <span className="seasonal-ribbon__star" aria-hidden="true">
      ★
    </span>
  </div>
);

const SeasonalRibbon: React.FC = () => {
  const { activeTheme } = useTheme();
  const themeConfig = RIBBON_CONFIG[activeTheme.id];

  if (!themeConfig) return null;

  return (
    <div
      className="seasonal-ribbon"
      role="complementary"
      aria-label="Seasonal greeting"
    >
      <Pennant config={themeConfig} />
    </div>
  );
};

export default SeasonalRibbon;
